import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

const AdvancedShippingOptions = ({ values, dispatchInputChangeCallback, dispatchCheckboxChangeCallback }) => {
    // Exact Profile state mapping requested
    const profile = useSelector(state => state.profile);

    // Exact event logic methods requested
    const onSignatureChange = e => {
        const { name } = e.target;
        dispatchCheckboxChangeCallback(name, e.target.checked);
    };

    const handleInputChange = e => {
        const { name, value } = e.target;
        dispatchInputChangeCallback(name, value);
    };

    return (
        <Card 
            sx={{ 
                width: '100%',
                backgroundColor: '#FFFFFF',
                border: '1px solid #E2E8F0',
                borderRadius: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                overflow: 'hidden'
            }}
            className="sc--cardhead--details"
        >
            <CardHeader 
                title={
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                        Shipping Options
                    </Typography>
                } 
                sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
            />
            <Divider sx={{ borderColor: '#E2E8F0' }} />
            
            <CardContent sx={{ p: 3, boxSizing: 'border-box' }}>
                <Stack spacing={2.5}>
                    {/* 6. Advanced Carrier Target Validation Action Checkboxes Panel Module Field Group */}
                    <Box sx={{ p: 2, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormGroup className="trial__page__checkbox">
                                    <FormControlLabel
                                        control={
                                            <Checkbox 
                                                checked={!!values.is_signature_required} 
                                                name="is_signature_required" 
                                                onChange={onSignatureChange} 
                                                sx={{ '&.Mui-checked': { color: '#1976d2' } }} 
                                            />
                                        }
                                        label={<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>Signature Required</Typography>}
                                    />
                                </FormGroup>
                            </Grid>
                            
                            {profile && profile.profile && profile.profile.show_deliver_to_po_address !== 0 && (
                                <Grid item xs={12} sm={4}>
                                    <FormGroup className="trial__page__checkbox">
                                        <FormControlLabel
                                            control={
                                                <Checkbox 
                                                    checked={!!values.is_deliver_to_po_address} 
                                                    name="is_deliver_to_po_address" 
                                                    onChange={onSignatureChange} 
                                                    sx={{ '&.Mui-checked': { color: '#1976d2' } }} 
                                                />
                                            }
                                            label={<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>Deliver to Post Office</Typography>}
                                        />
                                    </FormGroup>
                                </Grid>
                            )}
                            
                            {profile && profile.profile && profile.profile.is_show_leave_at_door_enabled === true && (
                                <Grid item xs={12} sm={4}>
                                    <FormGroup className="trial__page__checkbox">
                                        <FormControlLabel
                                            control={
                                                <Checkbox 
                                                    checked={!!values.is_leave_at_door_shipment} 
                                                    name="is_leave_at_door_shipment" 
                                                    onChange={onSignatureChange} 
                                                    sx={{ '&.Mui-checked': { color: '#1976d2' } }} 
                                                />
                                            }
                                            label={<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>Leave at Door</Typography>}
                                        />
                                    </FormGroup>
                                </Grid>
                            )}
                        </Grid>
                    </Box>

                    {/* 7. Special Delivery Handling Operational Requirements Metadata Comments Module Field */}
                    {profile && profile.profile && profile.profile.delivery_notes_enable === true && (
                        <Box sx={{ width: '100%' }}>
                            <TextField 
                                id="standard-basic"
                                label="Delivery Notes"
                                variant="outlined"
                                size="small"
                                name="delivery_notes"
                                value={values.delivery_notes || ''}
                                inputProps={{ maxLength: 35 }}
                                onChange={handleInputChange}
                                sx={{ 
                                    width: '100%', 
                                    '& .MuiOutlinedInput-root': { 
                                        borderRadius: '10px',
                                        '& fieldset': { borderColor: '#E2E8F0' },
                                        '&:hover fieldset': { borderColor: '#CBD5E1' },
                                        '&.Mui-focused fieldset': { borderColor: '#1976d2' }
                                    } 
                                }}
                            />
                        </Box>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default AdvancedShippingOptions;